<template>
  <!--    <div id="app" :class="$route.name">-->
  <!--        <b-navbar toggleable="lg" type="light" style="background-color: #ffffff">-->

  <!--           <b-navbar-brand href="#">-->
  <!--                <img src="../assets/epg_migration_logo.png" alt="EPG Migration Logo"-->
  <!--                                          class="logo"/>-->
  <!--            </b-navbar-brand>-->

  <!--            <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>-->

  <!--            <b-collapse id="nav-collapse" is-nav>-->

  <!--                <b-navbar-nav>-->
  <!--                    <b-nav-text class="text-left">-->
  <!--                       <small style="color: #2A1EAA">Fee Agreement</small>-->
  <!--                        <h6 style="color:#2c3e50">{{ projectName }}</h6>-->
  <!--                    </b-nav-text>-->
  <!--                </b-navbar-nav>-->

  <!--                <b-navbar-nav class="ml-auto">-->

  <!--                    <b-nav-form>-->
  <!--                        <b-button size="sm" @click.prevent="$refs.contactUsFormModal.show()">-->
  <!--                            <font-awesome-icon icon="question-circle" class="mr-1" /> Request Assistance-->
  <!--                        </b-button>-->
  <!--                    </b-nav-form>-->

  <!--                    <b-nav-item-dropdown right>-->
  <!--                        &lt;!&ndash; Using 'button-content' slot &ndash;&gt;-->
  <!--                        <template v-slot:button-content>-->
  <!--                            Logged in as {{ clientName }}-->
  <!--                        </template>-->

  <!--                        <b-dropdown-item href="#" @click.prevent="logout" >-->
  <!--                              Sign Out <font-awesome-icon icon="sign-out-alt" />-->
  <!--                        </b-dropdown-item>-->

  <!--                    </b-nav-item-dropdown>-->
  <!--                </b-navbar-nav>-->

  <!--            </b-collapse>-->

  <!--        </b-navbar>-->

  <!--        <div class="main-content">-->
  <!--            <b-container>-->
  <!--                <router-view></router-view>-->
  <!--            </b-container>-->
  <!--        </div>-->

  <!--        <contact-us-form-modal ref="contactUsFormModal" />-->
  <!--    </div>-->

  <div class="h-screen bg-white overflow-hidden dark:bg-darkSecondary">
    <div class="mx-auto flex justify-center items-center p-4">
      <button
        v-if="showFooter"
        :class="`btn btn--default mr-2 text-black invisible ${
          needHelpButton.isClicked
            ? 'disabled opacity-20 cursor-not-allowed'
            : ''
        }`"
      >
        Need Help?
      </button>
      <a
        @click.prevent="logout"
        class="btn btn--default text-black flex cursor-pointer invisible"
        v-if="$route.name !== 'signed'"
      >
        <span class="hidden md:block">Log Out</span>
        <LogInIcon size="1.5x" class="mt-0.5 text-black" />
      </a>

      <div class="flex justify-center flex-1">
        <div class="flex flex-shrink-0 transition-all ease-in-out">
          <a class="flex hover:border-0">
            <span class="sr-only">Xemplo</span>
            <img class="h-8 w-auto sm:h-10" src="/logo.svg" alt="Xemplo" />
          </a>
        </div>
      </div>
      <button
        v-if="showFooter"
        :class="`btn btn--default mr-2 text-black ${
          needHelpButton.isClicked
            ? 'disabled opacity-20 cursor-not-allowed'
            : ''
        }`"
        @click="buttonClicked('needHelp')"
      >
        Need Help?
      </button>
      <a
        @click.prevent="logout"
        class="btn btn--default text-black flex cursor-pointer"
        v-if="$route.name !== 'signed'"
      >
        <span class="hidden md:block">Log Out</span>
        <LogInIcon size="1.5x" class="mt-0.5 text-black" />
      </a>
    </div>
    <div class="w-full">
      <div style="position: fixed; bottom: 3%; width: 100%; z-index: 9999;">
        <div class="mx-auto max-w-screen-1920 px-8" v-if="haveFooter">
          <div class="grid grid-cols-12 gap-4">
            <div class="col-start-1 lg:col-start-2 col-span-12 lg:col-span-10">
              <div class="opacity-20"></div>
              <div class="flex justify-center" style="padding-bottom: 25px;">
                <button
                  :class="`btn btn--primary text-white ${
                    continueButton.isClicked || !continueButton.isEnabled
                      ? 'disabled opacity-20 cursor-not-allowed'
                      : ''
                  }`"
                  @click="buttonClicked('continue')"
                >
                  {{ continueButton.text }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <template v-if="showFooter">
        <div
          :class="`dark:bg-darkPrimary mx-4 mb-4 rounded-md relative pt-4 lg:pt-0 px-4 overflow-x-hidden overflow-y-auto`"
          style="max-height: calc(100vh - 165px)"
        >
          <div class="mx-auto max-w-screen-1920" id="wrapper">
            <router-view></router-view>
          </div>
        </div>
      </template>

      <template v-else>
        <div
          :class="`dark:bg-darkPrimary mx-4 mb-4 rounded-md relative pt-4 lg:pt-0 px-4 overflow-visible`"
          style="max-height: calc(100vh - 100px)"
        >
          <div class="mx-auto max-w-screen-1920">
            <router-view></router-view>
          </div>
        </div>
      </template>
      
      
    </div>
  </div>
</template>

<script>
/* eslint-disable */

import { bus } from "@/js/Bus";
import ContactUsFormModal from "@/components/modals/ContactUs";
import { LogInIcon } from "vue-feather-icons";
import { mapActions, mapGetters } from "vuex";

export default {
  components: {
    ContactUsFormModal,
    LogInIcon,
  },
  data() {
    return {
      isAuth: false,
      user: null,
      haveFooter: true
    };
  },
  watch: {
    showFooter: function (val) {
      this.haveFooter = val
    }
  },
  methods: {
    ...mapActions({
      setContinueButton: "client/setContinueButton",
      setNeedHelpButton: "client/setNeedHelpButton",
      setShowFooter: 'client/setShowFooter',
    }),
    buttonClicked(type) {
      console.log("clicked", type);
      if (type === "continue") {
        if (!this.continueButton.isClicked && this.continueButton.isEnabled) {
          this.setContinueButton({ isClicked: true, text: "saving..." });
        }
      } else if (type === "needHelp" && this.needHelpButton.isEnabled) {
        if (!this.needHelpButton.isClicked) {
          this.setNeedHelpButton({ isClicked: true });
        }
      }
    },
    scrollTop: function () {
      document.getElementById("wrapper").scrollIntoView();
    },
    setAuthenticatedUser() {
      var vm = this;

      this.$http.get(window.app.version + "/user").then(function (response) {
        vm.user = response.data;
      });
    },

    init() {
      var vm = this;
      if (this.$auth.authenticated()) {
        vm.isAuth = true;
        //vm.setAuthenticatedUser();
      }
    },
  },

  created() {
    var vm = this;
    vm.init();
    bus.$on("authenticated", function () {
      vm.init();
    });
    this.setShowFooter(true);
  },
  mounted() {
    this.setShowFooter(true);
  },
  computed: {
    ...mapGetters({
      needHelpButton: "client/needHelpButton",
      continueButton: "client/continueButton",
      showFooter: "client/showFooter",
    }),
    projectName() {
      let project = this.getProject();
      let projectName = "";
      if (project) {
        projectName += project.visa.visa_subclass;
        projectName += project.visa.stream ? " - " + project.visa.stream : "";
      }

      return projectName;
    },
    clientName() {
      let client = this.getClient();
      return client ? client.name : "";
    },
  },
};
</script>

<style></style>
